import { Input, InputProps } from '@progress/kendo-react-inputs'
import { Error } from '@progress/kendo-react-labels'
import { useEffect } from 'react'

import { useGeovisualizadoresStore } from '../../../stores/geovisualizador'

import type { FieldRenderProps } from '@progress/kendo-react-form'

export default function ValidatedShareModalInput(
  fieldRenderProps: FieldRenderProps
) {
  const setShareModalIsValid = useGeovisualizadoresStore(
    (state) => state.setShareModalIsValid
  )
  const addShareModalValidatedField = useGeovisualizadoresStore(
    (state) => state.addShareModalValidatedField
  )

  useEffect(() => {
    setShareModalIsValid(!!fieldRenderProps.value)
    addShareModalValidatedField({
      [fieldRenderProps.name]: !!fieldRenderProps.value,
    })
  }, [fieldRenderProps.value])

  return (
    <div>
      <Input {...(fieldRenderProps as InputProps)} />
      {fieldRenderProps.visited && fieldRenderProps.validationMessage && (
        <Error>{fieldRenderProps.validationMessage}</Error>
      )}
    </div>
  )
}
